import React from "react";
import "../../../css/buttons/SecondaryButton.css";

const SecondaryButton = ({ onClick, text }) => {
  const handleClick =
    onClick ||
    (() => {
      const label = text?.toLowerCase() || "";

      if (label.includes("read faqs")) {
        document
          .querySelector("#faqs, [data-section='faqs']")
          ?.scrollIntoView({ behavior: "smooth" });
      }
    });

  return (
    <button type="button" className="secondary-button" onClick={handleClick}>
      <div className="button-text secondary">{text}</div>
    </button>
  );
};

export default SecondaryButton;
